import React from 'react';

import { Outlet } from 'react-router-dom';

import AnnouncementToast
  from '../../components/common/AnnouncementToast/AnnouncementToast';
import { DemoAnnouncementsProvider } from '../DemoAnnouncementsContext';

const DemoTryoutShell: React.FC = () => (
  <DemoAnnouncementsProvider>
    <AnnouncementToast />
    <Outlet />
  </DemoAnnouncementsProvider>
);

export default DemoTryoutShell;
